// authSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: false,
  user: {},
  loading: false,
  error: null,
  menu: "",
  rcsAgentId: "",
  rechargeKey: "",
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.isAuthenticated = true;
      state.menu = action.payload.data.menu;
      state.rcsAgentId = action.payload.data.rcsAgentId;
      state.rechargeKey = action.payload.data.rechargeKey;
      // state.menu="111111111111111111111111111111";
      state.dashboardlst = action.payload;
      state.user = action.payload;
      state.loading = false;
      state.error = null;
      sessionStorage.setItem(
        "token",
        JSON.stringify(action.payload.data.token)
      );
      sessionStorage.setItem(
        "jwtToken",
        JSON.stringify(action.payload.data.token)
      );
      sessionStorage.setItem(
        "username",
        JSON.stringify(action.payload.data.username)
      );
      sessionStorage.setItem(
        "loginTime",
        JSON.stringify(action.payload.data.lastLoginDate)
      );
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = {};
      state.loading = false;
      state.error = null;
      sessionStorage.clear();
      state.menu = "";
      state.rcsAgentId = "";
      state.rechargeKey = "";
      state.userType = "";
    },
  },
});

export const { loginSuccess, logout } = authSlice.actions;
export default authSlice.reducer;
